import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';

@Pipe({
	name: 'localizedDate',
	// Impur : le fuseau résolu par Intl côté SSR (serveur) diffère de celui du navigateur.
	// Forcer un recalcul à chaque CD pour que le client écrase le rendu SSR avec le bon fuseau.
	pure: false
})
export class LocalizedDatePipe implements PipeTransform {

	private datePipe: DatePipe;
	private userTimeZone: string;

	constructor(
		private translate: TranslateService
	) {
		this.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

		this.datePipe = new DatePipe(this.translate.currentLang);

		this.translate.onLangChange.subscribe(event => {
			this.datePipe = new DatePipe(event.lang);
		});
	}

	transform(
		value: Date | string | number,
		format: string = 'EEE d MMM',
		timezone: string = this.userTimeZone
	): string | null {
		if (!value) return null;

		let parsedValue = value;

		if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/.test(value)) {
			parsedValue = value + 'Z';
		}

		return this.datePipe.transform(parsedValue, format, timezone, this.translate.currentLang);
	}

}
